(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function syncAriaExpanded(details) {
    var summary = details.querySelector('.luban-perks__trigger');
    if (summary) {
      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    }
  }

  function initPerkItem(details) {
    if (!details || details.dataset.lubanPerkInit === 'true') return;
    details.dataset.lubanPerkInit = 'true';

    var summary = details.querySelector('.luban-perks__trigger');
    var panel = details.querySelector('.luban-perks__panel');
    if (!summary || !panel) return;

    syncAriaExpanded(details);

    details.addEventListener('toggle', function () {
      syncAriaExpanded(details);
    });

    if (REDUCED_MOTION) return;

    summary.addEventListener('click', function (event) {
      var willOpen = !details.open;

      if (willOpen) return;

      event.preventDefault();

      panel.style.height = panel.scrollHeight + 'px';
      panel.style.overflow = 'hidden';
      panel.style.transition = 'height 0.35s cubic-bezier(0.16, 1, 0.3, 1)';

      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });

      var onEnd = function () {
        panel.removeEventListener('transitionend', onEnd);
        details.removeAttribute('open');
        panel.style.height = '';
        panel.style.overflow = '';
        panel.style.transition = '';
        syncAriaExpanded(details);
      };

      panel.addEventListener('transitionend', onEnd);
    });
  }

  function initPerks(root) {
    if (!root || root.dataset.lubanPerksInit === 'true') return;
    root.dataset.lubanPerksInit = 'true';

    root.querySelectorAll('[data-luban-perk-item]').forEach(initPerkItem);
  }

  function initAll() {
    document.querySelectorAll('[data-luban-perks]').forEach(initPerks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
